import { render, staticRenderFns } from "./Survey.vue?vue&type=template&id=bb48da5e&scoped=true&"
import script from "./Survey.vue?vue&type=script&lang=js&"
export * from "./Survey.vue?vue&type=script&lang=js&"
import style0 from "./Survey.vue?vue&type=style&index=0&id=bb48da5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb48da5e",
  null
  
)

export default component.exports